import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import isEqual from 'lodash.isequal';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ng2-carouselamos.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

var _c0 = ["list"];
var _c1 = ["ng2-carouselamos", ""];
function Ng2CarouselamosComponent_4_ng_template_0_Template(rf, ctx) { }
var _c2 = function (a0, a1, a2) { return { $implicit: a0, index: a1, selectedIndex: a2 }; };
function Ng2CarouselamosComponent_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, Ng2CarouselamosComponent_4_ng_template_0_Template, 0, 0, "ng-template", 6);
} if (rf & 2) {
    var item_r5 = ctx.$implicit;
    var i_r6 = ctx.index;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.$item)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c2, item_r5, i_r6, ctx_r3.childIndex));
} }
function Ng2CarouselamosComponent_div_5_button_1_ng_template_1_Template(rf, ctx) { }
function Ng2CarouselamosComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function Ng2CarouselamosComponent_div_5_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(2); var _r2 = ɵngcc0.ɵɵreference(3); return ctx_r11.scroll(false, _r2); });
    ɵngcc0.ɵɵtemplate(1, Ng2CarouselamosComponent_div_5_button_1_ng_template_1_Template, 0, 0, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r8.amount >= 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.$prev);
} }
function Ng2CarouselamosComponent_div_5_button_2_ng_template_1_Template(rf, ctx) { }
function Ng2CarouselamosComponent_div_5_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function Ng2CarouselamosComponent_div_5_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); var ctx_r14 = ɵngcc0.ɵɵnextContext(2); var _r2 = ɵngcc0.ɵɵreference(3); return ctx_r14.scroll(true, _r2); });
    ɵngcc0.ɵɵtemplate(1, Ng2CarouselamosComponent_div_5_button_2_ng_template_1_Template, 0, 0, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    var _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r9.amount <= 0 - (_r2.scrollWidth - ctx_r9.width));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.$next);
} }
function Ng2CarouselamosComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, Ng2CarouselamosComponent_div_5_button_1_Template, 2, 2, "button", 8);
    ɵngcc0.ɵɵtemplate(2, Ng2CarouselamosComponent_div_5_button_2_Template, 2, 2, "button", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.$prev);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.$next);
} }
function SelectedItemInterface() { }
if (false) {
    /** @type {?} */
    SelectedItemInterface.prototype.item;
    /** @type {?} */
    SelectedItemInterface.prototype.index;
    /** @type {?} */
    SelectedItemInterface.prototype.first;
}
var Ng2CarouselamosComponent = /** @class */ (function () {
    function Ng2CarouselamosComponent() {
        this.childIndex = 0;
        this.amount = 0;
        this.startPress = 0;
        this.lastX = 0;
        this.startAt = 0;
        this.items = [];
        this.width = 500;
        this.onSelectedItem = new EventEmitter();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onMousedown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.which === 1) {
            this.startPress = e.clientX;
            this.lastX = this.amount;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onTouchdown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (navigator.userAgent.indexOf("Android") >= 0)
            e.preventDefault();
        this.startPress = e.targetTouches[0].clientX;
        this.lastX = this.amount;
    };
    /**
     * @param {?} e
     * @param {?} maxWidth
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onMousemove = /**
     * @param {?} e
     * @param {?} maxWidth
     * @return {?}
     */
    function (e, maxWidth) {
        if (e.which === 1) {
            /** @type {?} */
            var amount = this.lastX - (this.startPress - e.clientX);
            if (amount > 0 || amount < -(maxWidth - this.width))
                return;
            this.amount = amount;
        }
    };
    /**
     * @param {?} e
     * @param {?} maxWidth
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onTouchmove = /**
     * @param {?} e
     * @param {?} maxWidth
     * @return {?}
     */
    function (e, maxWidth) {
        if (navigator.userAgent.indexOf("Android") >= 0)
            e.preventDefault();
        /** @type {?} */
        var amount = this.lastX - (this.startPress - e.targetTouches[0].clientX);
        if (amount > 0 || amount < -(maxWidth - this.width))
            return;
        this.amount = amount;
    };
    /**
     * @param {?} e
     * @param {?} elem
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onMouseup = /**
     * @param {?} e
     * @param {?} elem
     * @return {?}
     */
    function (e, elem) {
        if (e.which === 1) {
            this.startPress = 0;
            this.snap(elem);
        }
    };
    /**
     * @param {?} e
     * @param {?} elem
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.onTouchup = /**
     * @param {?} e
     * @param {?} elem
     * @return {?}
     */
    function (e, elem) {
        if (navigator.userAgent.indexOf("Android") >= 0)
            e.preventDefault();
        this.startPress = 0;
        this.snap(elem);
    };
    /**
     * @param {?} elem
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.snap = /**
     * @param {?} elem
     * @return {?}
     */
    function (elem) {
        /** @type {?} */
        var counter = 0;
        /** @type {?} */
        var lastVal = 0;
        for (var i = 0; i < this.items.length; i++) {
            /** @type {?} */
            var el = elem.children[i];
            /** @type {?} */
            var style = el.currentStyle || window.getComputedStyle(el);
            counter +=
                el.offsetWidth +
                    (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
            if (this.amount <= lastVal && this.amount >= -counter) {
                this.amount = -lastVal;
                this.childIndex = i;
                this.onSelectedItem.emit({
                    item: this.items[this.childIndex],
                    index: this.childIndex,
                    first: false
                });
                return;
            }
            lastVal = counter;
        }
        return counter;
    };
    /**
     * @param {?} forward
     * @param {?} elem
     * @param {?=} qty
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.scroll = /**
     * @param {?} forward
     * @param {?} elem
     * @param {?=} qty
     * @return {?}
     */
    function (forward, elem, qty) {
        if (qty === void 0) { qty = 1; }
        this.childIndex += forward ? qty : -qty;
        this.onSelectedItem.emit({
            item: this.items[this.childIndex],
            index: this.childIndex,
            first: false
        });
        this.amount = -this.calcScroll(elem);
    };
    /**
     * @param {?} elem
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.calcScroll = /**
     * @param {?} elem
     * @return {?}
     */
    function (elem) {
        /** @type {?} */
        var counter = 0;
        for (var i = this.childIndex - 1; i >= 0; i--) {
            /** @type {?} */
            var el = elem.children[i];
            /** @type {?} */
            var style = el.currentStyle || window.getComputedStyle(el);
            counter +=
                el.offsetWidth +
                    (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
        }
        return counter;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.items &&
            !isEqual(changes.items.previousValue, changes.items.currentValue)) {
            if (changes.items.firstChange) {
                this.onSelectedItem.emit({
                    item: this.items[this.childIndex],
                    index: this.childIndex,
                    first: true
                });
            }
            this.amount = 0;
        }
    };
    /**
     * @return {?}
     */
    Ng2CarouselamosComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.startPress = 1;
        this.scroll(true, this.list.nativeElement, this.startAt);
        setTimeout((/**
         * @return {?}
         */
        function () { return (_this.startPress = 0); }));
    };
    Ng2CarouselamosComponent.propDecorators = {
        startAt: [{ type: Input }],
        items: [{ type: Input }],
        width: [{ type: Input }],
        $prev: [{ type: Input }],
        $next: [{ type: Input }],
        $item: [{ type: Input }],
        onSelectedItem: [{ type: Output }],
        list: [{ type: ViewChild, args: ["list", { static: true },] }]
    };
Ng2CarouselamosComponent.ɵfac = function Ng2CarouselamosComponent_Factory(t) { return new (t || Ng2CarouselamosComponent)(); };
Ng2CarouselamosComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Ng2CarouselamosComponent, selectors: [["", "ng2-carouselamos", ""]], viewQuery: function Ng2CarouselamosComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
    } }, inputs: { startAt: "startAt", items: "items", width: "width", $prev: "$prev", $next: "$next", $item: "$item" }, outputs: { onSelectedItem: "onSelectedItem" }, features: [ɵngcc0.ɵɵNgOnChangesFeature()], attrs: _c1, decls: 6, vars: 13, consts: [[1, "ng2-carouselamos-container"], [1, "ng2-carouselamos-wrapper", 3, "mousedown", "touchstart", "mousemove", "touchmove", "mouseup", "mouseleave", "touchend"], [1, "ng2-carouselamos"], ["list", ""], [4, "ngFor", "ngForOf"], ["class", "controls", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "controls"], ["type", "button", 3, "disabled", "click", 4, "ngIf"], ["type", "button", 3, "disabled", "click"], [3, "ngTemplateOutlet"]], template: function Ng2CarouselamosComponent_Template(rf, ctx) { if (rf & 1) {
        var _r16 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("mousedown", function Ng2CarouselamosComponent_Template_div_mousedown_1_listener($event) { return ctx.onMousedown($event); })("touchstart", function Ng2CarouselamosComponent_Template_div_touchstart_1_listener($event) { return ctx.onTouchdown($event); })("mousemove", function Ng2CarouselamosComponent_Template_div_mousemove_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var _r2 = ɵngcc0.ɵɵreference(3); return ctx.onMousemove($event, _r2.scrollWidth); })("touchmove", function Ng2CarouselamosComponent_Template_div_touchmove_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var _r2 = ɵngcc0.ɵɵreference(3); return ctx.onTouchmove($event, _r2.scrollWidth); })("mouseup", function Ng2CarouselamosComponent_Template_div_mouseup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var _r2 = ɵngcc0.ɵɵreference(3); return ctx.onMouseup($event, _r2); })("mouseleave", function Ng2CarouselamosComponent_Template_div_mouseleave_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var _r2 = ɵngcc0.ɵɵreference(3); return ctx.onMouseup($event, _r2); })("touchend", function Ng2CarouselamosComponent_Template_div_touchend_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var _r2 = ɵngcc0.ɵɵreference(3); return ctx.onTouchup($event, _r2); });
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵtemplate(4, Ng2CarouselamosComponent_4_Template, 1, 6, undefined, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, Ng2CarouselamosComponent_div_5_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.width + "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("transition", ctx.startPress > 0 ? "none" : "-webkit-transform 1s")("webkit-transition", ctx.startPress > 0 ? "none" : "-webkit-transform 1s")("transform", "translateX(" + ctx.amount + "px)")("webkit-transform", "translateX(" + ctx.amount + "px)");
        ɵngcc0.ɵɵattribute("startPress", ctx.startPress);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.$prev || ctx.$next);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [".ng2-carouselamos-container[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:center}.ng2-carouselamos-wrapper[_ngcontent-%COMP%]{overflow:hidden}.ng2-carouselamos[_ngcontent-%COMP%]{display:flex;transition:transform 1s}.controls[_ngcontent-%COMP%]{pointer-events:none;position:absolute;display:flex;width:100%;justify-content:space-between;top:50%;left:0;transform:translateY(-50%)}.controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{pointer-events:all;background:0 0;border:0}"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Ng2CarouselamosComponent, [{
        type: Component,
        args: [{
                selector: "[ng2-carouselamos]",
                template: "<div class=\"ng2-carouselamos-container\">\n  <div\n    class=\"ng2-carouselamos-wrapper\"\n    [style.width]=\"width + 'px'\"\n    (mousedown)=\"onMousedown($event)\"\n    (touchstart)=\"onTouchdown($event)\"\n    (mousemove)=\"onMousemove($event, list.scrollWidth)\"\n    (touchmove)=\"onTouchmove($event, list.scrollWidth)\"\n    (mouseup)=\"onMouseup($event, list)\"\n    (mouseleave)=\"onMouseup($event, list)\"\n    (touchend)=\"onTouchup($event, list)\"\n  >\n    <div\n      class=\"ng2-carouselamos\"\n      [attr.startPress]=\"startPress\"\n      [style.transition]=\"startPress > 0 ? 'none' : '-webkit-transform 1s'\"\n      [style.webkitTransition]=\"\n        startPress > 0 ? 'none' : '-webkit-transform 1s'\n      \"\n      [style.transform]=\"'translateX(' + amount + 'px)'\"\n      [style.webkitTransform]=\"'translateX(' + amount + 'px)'\"\n      #list\n    >\n      <ng-template\n        *ngFor=\"let item of items; let i = index\"\n        [ngTemplateOutlet]=\"$item\"\n        [ngTemplateOutletContext]=\"{\n          $implicit: item,\n          index: i,\n          selectedIndex: childIndex\n        }\"\n      ></ng-template>\n    </div>\n  </div>\n  <div class=\"controls\" *ngIf=\"$prev || $next\">\n    <button\n      type=\"button\"\n      *ngIf=\"$prev\"\n      (click)=\"scroll(false, list)\"\n      [disabled]=\"amount >= 0\"\n    >\n      <ng-template [ngTemplateOutlet]=\"$prev\"></ng-template>\n    </button>\n    <button\n      type=\"button\"\n      *ngIf=\"$next\"\n      (click)=\"scroll(true, list)\"\n      [disabled]=\"amount <= -(list.scrollWidth - width)\"\n    >\n      <ng-template [ngTemplateOutlet]=\"$next\"></ng-template>\n    </button>\n  </div>\n</div>\n",
                styles: [".ng2-carouselamos-container{position:relative;display:flex;justify-content:center}.ng2-carouselamos-wrapper{overflow:hidden}.ng2-carouselamos{display:flex;transition:transform 1s}.controls{pointer-events:none;position:absolute;display:flex;width:100%;justify-content:space-between;top:50%;left:0;transform:translateY(-50%)}.controls button{pointer-events:all;background:0 0;border:0}"]
            }]
    }], function () { return []; }, { startAt: [{
            type: Input
        }], items: [{
            type: Input
        }], width: [{
            type: Input
        }], onSelectedItem: [{
            type: Output
        }], $prev: [{
            type: Input
        }], $next: [{
            type: Input
        }], $item: [{
            type: Input
        }], list: [{
            type: ViewChild,
            args: ["list", { static: true }]
        }] }); })();
    return Ng2CarouselamosComponent;
}());
if (false) {
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.childIndex;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.amount;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.startPress;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.lastX;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.startAt;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.items;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.width;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.$prev;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.$next;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.$item;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.onSelectedItem;
    /** @type {?} */
    Ng2CarouselamosComponent.prototype.list;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ng2-carouselamos.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Ng2CarouselamosModule = /** @class */ (function () {
    function Ng2CarouselamosModule() {
    }
Ng2CarouselamosModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: Ng2CarouselamosModule });
Ng2CarouselamosModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function Ng2CarouselamosModule_Factory(t) { return new (t || Ng2CarouselamosModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Ng2CarouselamosModule, { declarations: function () { return [Ng2CarouselamosComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [Ng2CarouselamosComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Ng2CarouselamosModule, [{
        type: NgModule,
        args: [{
                declarations: [Ng2CarouselamosComponent],
                imports: [CommonModule],
                exports: [Ng2CarouselamosComponent]
            }]
    }], function () { return []; }, null); })();
    return Ng2CarouselamosModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ng2-carouselamos.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Ng2CarouselamosComponent, Ng2CarouselamosModule };

//# sourceMappingURL=ng2-carouselamos.js.map